import api from './api';
import types from './mutation-types';

export default {
	/**call API */
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);

			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setRtnPartInfoInit_({ commit }) {
		commit(types.RTN_PART_INFO_INIT);
	},
	//고품회수신청정보 state commit
	setRtnPartInfo_({ commit }, { key, value }) {
		commit(types.RTN_PART_INFO, { key, value });
	},
	//고품회수목록 조회
	getRtnPartMstList_({ commit, state }) {
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { searchParams, pagingInfo } = state;
		return api
			.getRtnPartMstList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'rtnPartMstList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},

	//고품회수신청 상세정보
	getRtnPartInfo_({ commit, state }, param) {
		return api
			.getRtnPartInfo(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'rtnPartInfo',
						value: data?.body.result || {}
					});
					if (data.body.result.clctWay == '20') {
						commit(types.RTN_PART_INFO, {
							key: 'dlvfYn',
							value: ''
						});
					}
					if (data.body.result.rptpSt == '' || data.body.result.rptpSt == null) {
						commit(types.RTN_PART_INFO, {
							key: 'readOnlyAuth2',
							value: true
						});
						commit(types.RTN_PART_INFO, {
							key: 'btnTsAuth1',
							value: true
						});
						commit(types.RTN_PART_INFO, {
							key: 'btnApAuth1',
							value: true
						});
					} else if (data.body.result.rptpSt != '' || data.body.result.rptpSt != null) {
						if (data.body.result.rptpSt === '10') {
							commit(types.RTN_PART_INFO, {
								key: 'btnTsAuth2',
								value: true
							});
							commit(types.RTN_PART_INFO, {
								key: 'btnApAuth2',
								value: true
							});
						} else if (data.body.result.rptpSt === '20') {
							commit(types.RTN_PART_INFO, {
								key: 'btnApprAuth',
								value: true
							});
						}
						commit(types.RTN_PART_INFO, {
							key: 'readOnlyAuth1',
							value: data.body.result.rptpSt == '10' || data.body.result.rptpSt == '20' || data.body.result.rptpSt == '99' ? true : false
						});
						commit(types.RTN_PART_INFO, {
							key: 'readOnlyAuth2',
							value: data.body.result.rptpSt == '20' || data.body.result.rptpSt == '99' ? true : false
						});
					}
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},

	// 고품회수신청 임시저장버튼
	async SaveRtnPartInfo_(store, { saveParams }) {
		return api
			.saveRtnPartInfo({ saveParams })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	// 고품회수 신청버튼
	async UpdateRtnPartSt_(store, { rptpNo, updateParams }) {
		const saveParams = updateParams;
		return api
			.saveRtnPartInfo({ saveParams })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	// 고품출고정보 수정
	async UpdateRtnPartInfo_(store, { saveParams }) {
		return api
			.updateRtnPartInfo({ saveParams })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	// 고품회수신청 완료
	async UpdateRtnPartCmpl_(store, { rptpNo, updateParams }) {
		return api
			.updateRtnPartCmpl({ rptpNo, updateParams })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},

	setBtnTsAuth_({ commit, state }, paramAuth) {
		//임시저장버튼 권한설정
		let rptpSt = state.rtnPartInfo.rptpSt || '';
		let result = false;

		if (paramAuth) {
			if (rptpSt == '') {
				result = true;
			} else {
				//처리단계가 임시저장이 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				result = false;
			}
		} else {
			result = false;
		}

		commit(types.RTN_PART_INFO, {
			key: 'btnTsAuth1',
			value: result
		});
	},

	setBtnApAuth_({ commit, state }, paramAuth) {
		//신청버튼 권한설정
		let rptpSt = state.rtnPartInfo.rptpSt || '';
		let result = false;

		if (paramAuth) {
			if (rptpSt == '') {
				result = true;
			} else {
				//처리단계가 임시저장이 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				result = false;
			}
		} else {
			result = false;
		}

		commit(types.RTN_PART_INFO, {
			key: 'btnApAuth1',
			value: result
		});
	},

	setBtnIcAuth_({ commit, state }, paramAuth) {
		//신청버튼 권한설정
		let rptpSt = state.rtnPartInfo.rptpSt || '';
		let result = false;

		if (paramAuth) {
			if ((rptpSt == '' || rptpSt == '20') && !this.isMqyStation) {
				result = true;
			} else {
				//처리단계가 임시저장이 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				result = false;
			}
		} else {
			result = false;
		}

		commit(types.RTN_PART_INFO, {
			key: 'btnApprAuth',
			value: result
		});
	}
};
